<template>
  <div
    class="status"
    id="tooltip-target-1"
    v-b-tooltip.hover
    :title="toTitleCase(type)"
    :style="styles"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-if="isSuccessful"
    >
      <circle cx="12" cy="12" r="12" fill="#15CE9A" fill-opacity="0.15" />
      <path
        d="M16 9L9.8125 15L7 12.2727"
        stroke="#15CE9A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="isPending"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#FFFFBB" fill-opacity="0.5" />
      <path
        d="M11.5 19C15.0899 19 18 16.0899 18 12.5C18 8.91015 15.0899 6 11.5 6C7.91015 6 5 8.91015 5 12.5C5 16.0899 7.91015 19 11.5 19Z"
        stroke="#FFBF00"
        stroke-opacity="0.85"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.5 8.60004V12.5L14.1 13.8"
        stroke="#FFBF00"
        stroke-opacity="0.85"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="isProcessing"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#17A0FB" fill-opacity="0.1" />
      <path
        d="M14.6667 9L17.6667 12L14.6667 15"
        stroke="#17A0FB"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.6667 9L13.6667 12L10.6667 15"
        stroke="#17A0FB"
        stroke-opacity="0.6"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 9L10 12L7 15"
        stroke="#17A0FB"
        stroke-opacity="0.3"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else-if="isUnknown"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#030D18" fill-opacity="0.1" />
      <path
        d="M14.6667 9L17.6667 12L14.6667 15"
        stroke="#030D18"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.6667 9L13.6667 12L10.6667 15"
        stroke="#030D18"
        stroke-opacity="0.6"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 9L10 12L7 15"
        stroke="#030D18"
        stroke-opacity="0.3"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#C61010" fill-opacity="0.1" />
      <path
        d="M15 9L9 15"
        stroke="#C61010"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 9L15 15"
        stroke="#C61010"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>
<script>
import startCase from "lodash/startCase";
export default {
  name: "StatusIndicator",
  props: {
    type: String,
    styles: String,
    exact: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    allowedStatus: [
      "failed",
      "successful",
      "active",
      "inactive",
      "pending",
      "cancelled",
      "others",
      "pending_customer_approval",
      "pending_kyc_review",
      "settled",
        "up",
        "down",
        "unstable"
    ],
  }),
  methods: {
    toTitleCase(value) {
      if (value) {
        let change =
          value.toLowerCase() === "active"
            ? "successful"
            : value.toLowerCase() === "inactvie"
            ? "failed"
            : value;
        if (this.exact) {
          change = value;
        }
        return startCase(change.toLowerCase());
      } else {
        return "Other";
      }
    },
  },
  computed: {
    isSuccessful() {
      return ["successful", "settled", "active", "up"].includes(
        this.type ? this.type.toString().toLowerCase() : false
      );
    },
    isFailed() {
      return ["inactive", "failed", "stop", "unsettled", "down", "declined"].includes(
        this.type ? this.type.toString().toLowerCase() : false
      );
    },
    isPending() {
      return ["pending", "pending_customer_approval", "stop", "unstable"].includes(
        this.type ? this.type.toString().toLowerCase() : false
      );
    },
    isProcessing() {
      return ["processing", "pending_kyc_review"].includes(
        this.type ? this.type.toString().toLowerCase() : false
      );
    },
    isCancelled() {
      return ["cancelled", "stopped"].includes(
        this.type ? this.type.toString().toLowerCase() : ""
      );
    },
    isUnknown() {
      return ["unknown", "other", null].includes(
        this.type ? this.type.toString().toLowerCase() : null
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.status {
  // width: 1px;
  // height: 1px;
  border-radius: 100%;
  // background: #ccc;

  padding: 5px;
  // margin-top: 3px;
  margin-right: 7px;
  span {
    color: transparent;
  }
}
</style>
<style>
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.428571429;
  line-break: auto;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  white-space: normal;
  font-size: 12px;
  filter: alpha(opacity=0);
  /* opacity: 0; */
}
.tooltip.in {
  filter: alpha(opacity=90);
  opacity: 0.9;
}
.tooltip.top {
  padding: 5px 0;
  margin-top: -3px;
}
.tooltip.right {
  padding: 0 5px;
  margin-left: 3px;
}
.tooltip.bottom {
  padding: 5px 0;
  margin-top: 3px;
}
.tooltip.left {
  padding: 0 5px;
  margin-left: -3px;
}
.tooltip.top .tooltip-arrow {
  bottom: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}
.tooltip.top-left .tooltip-arrow {
  right: 5px;
  bottom: 0;
  margin-bottom: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}
.tooltip.top-right .tooltip-arrow {
  bottom: 0;
  left: 5px;
  margin-bottom: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}
.tooltip.right .tooltip-arrow {
  top: 50%;
  left: 0;
  margin-top: -5px;
  border-width: 5px 5px 5px 0;
  border-right-color: #000;
}
.tooltip.left .tooltip-arrow {
  top: 50%;
  right: 0;
  margin-top: -5px;
  border-width: 5px 0 5px 5px;
  border-left-color: #000;
}
.tooltip.bottom .tooltip-arrow {
  top: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000;
}
.tooltip.bottom-left .tooltip-arrow {
  top: 0;
  right: 5px;
  margin-top: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000;
}
.tooltip.bottom-right .tooltip-arrow {
  top: 0;
  left: 5px;
  margin-top: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000;
}
.tooltip-inner {
  max-width: 200px;
  padding: 3px 8px;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 4px;
}
.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
</style>
